// @ts-check

/**
 * @param {string} listName
 */
export const handleCreateListAnalyticsEvent = (listName = '') => {
  const event = new CustomEvent('CreateListEvent', {
    detail: listName,
  });
  document.dispatchEvent(event);
};

/**
 * @param {string} listName
 */
export const handleDeleteListAnalyticsEvent = (listName = '') => {
  const event = new CustomEvent('DeleteListEvent', {
    detail: listName,
  });
  document.dispatchEvent(event);
};
